import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/common";
import { NetworkPanel } from "@/components/Network";

export default function Rete() {
  const [q, setQ] = useState("");
  return (
    <div data-testid="network-page">
      <PageHeader title="Rete" subtitle="Amministratori, soci e dipendenti della tua azienda" />
      <div className="relative mb-4 max-w-sm">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9" placeholder="Cerca per nome, email, reparto" value={q} onChange={(e) => setQ(e.target.value)} data-testid="network-search-input" />
      </div>
      <NetworkPanel q={q} />
    </div>
  );
}
